<template>
  <div>
  <Datetime v-model="requestDate"
    type="datetime"
    :minute-step="1"
    zone="Asia/Tokyo"
    value-zone="Asia/Tokyo"
    :hidden-name="attribute_name"
    format="yyyy-MM-dd HH:mm:ss"
    input-class="form-control"
    class="theme-orange"
    :placeholder="placeholder"></Datetime>
    <button type="button" class="btn btn-primary mt-1" @click="clear">Clear</button>
  </div>
</template>
<script>
import moment from 'moment'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'

export default {
  props: {
    from: String,
    attribute_name: String,
    placeholder: String,
  },
  components: {
    Datetime
  },
  data() {
    return {
      requestDate: moment(this.from).format('YYYY-MM-DDTHH:mm:ss')
    }
  },
  methods: {
    clear () {
      this.requestDate = null;
    }
  },
  computed: {
    start() {
      // min-date に明日の9時を指定
//      const start = moment().add(1, 'days').hour(8)
//      return start.format('YYYY-MM-DDTHH:mm:ss')
    },
    end() {
      // max-date に min-date から3ヶ月後を指定
//      const start = moment(this.start)
//      const end = start.add(3, 'months').endOf('day')
//      return end.format('YYYY-MM-DDTHH:mm:ss')
    }
  }
}
</script>
